import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import cx from 'classnames';
import i18n from 'i18next';
import { useSelector } from 'react-redux';
import { TablePagination } from '@material-ui/core';
import Tabs from '../ui/react-ui/tabs';
import DataTable from '../ui/table';
import SearchBar from '../ui/searchBar';
import TerminalBoardViewDetail from './terminalBoardView-detail'; // api

import { getTerminalBoardMessageList } from '../../api/settingAPI';
var t = i18n.getFixedT(null, 'board-terminalBoardView');
var gt = i18n.getFixedT(null, 'app');
var TerminalBoardView = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      terminalsList = _useSelector.app.terminalsList;

  var id = props.id;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      tabsMenu = _useState2[0],
      setTabsMenu = _useState2[1];

  var _useState3 = useState(''),
      _useState4 = _slicedToArray(_useState3, 2),
      currentTab = _useState4[0],
      setCurrentTab = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      currentPage = _useState6[0],
      setCurrentPage = _useState6[1];

  var _useState7 = useState(0),
      _useState8 = _slicedToArray(_useState7, 2),
      totalCount = _useState8[0],
      setTotalCount = _useState8[1];

  var _useState9 = useState(10),
      _useState10 = _slicedToArray(_useState9, 2),
      rowsPerPage = _useState10[0],
      setRowsPerPage = _useState10[1];

  var _useState11 = useState({}),
      _useState12 = _slicedToArray(_useState11, 2),
      tableData = _useState12[0],
      setTableData = _useState12[1];

  var _useState13 = useState({
    field: 'beginTime',
    desc: true
  }),
      _useState14 = _slicedToArray(_useState13, 2),
      tableSort = _useState14[0],
      setTableSort = _useState14[1];

  var _useState15 = useState(''),
      _useState16 = _slicedToArray(_useState15, 2),
      keyword = _useState16[0],
      setKeyword = _useState16[1];

  var _useState17 = useState({}),
      _useState18 = _slicedToArray(_useState17, 2),
      detailData = _useState18[0],
      setDetailData = _useState18[1];

  var handleChangeRowsPerPage = function handleChangeRowsPerPage(e) {
    setRowsPerPage(parseInt(e.target.value, 10));
    setCurrentPage(0);
  };

  var fetchTerminalBoardList = function fetchTerminalBoardList() {
    var offset = (Number(currentPage + 1) - 1) * rowsPerPage;
    getTerminalBoardMessageList(contextRoot, false, keyword, tableSort, offset, rowsPerPage, currentTab).then(function (result) {
      if (result.totalElements !== totalCount) setTotalCount(result.totalElements);

      var newData = _.cloneDeep(result.content);

      _.map(newData, function (el, index) {
        el.sequence = offset + index + 1;
      });

      setTableData(newData);
    });
  };

  var handleOpenDialog = function handleOpenDialog() {
    var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    setDetailData(data);
  };

  var handleCloseDialog = function handleCloseDialog(act) {
    setDetailData({});
  };

  useEffect(function () {
    if (currentTab === '') return;
    fetchTerminalBoardList();
  }, [currentTab, keyword, JSON.stringify(tableSort), currentPage, rowsPerPage]);
  useEffect(function () {
    var newTabsMenu = [];

    _.map(terminalsList, function (el) {
      newTabsMenu.push({
        key: el.value,
        title: el.text
      });
      setTabsMenu(newTabsMenu);
      setCurrentTab(newTabsMenu[0].key);
    });
  }, [terminalsList]);
  var fields = {};

  _.set(fields, 'sequence', {
    label: t('lbl-sequence')
  });

  _.set(fields, 'title', {
    label: t('lbl-title'),
    sortable: true
  });

  _.set(fields, 'description', {
    label: t('lbl-description'),
    sortable: true,
    formatter: function formatter(val, row) {
      if (_.isEmpty(val)) return null;

      var textAry = _.split(val, /\r?\n/g);

      return textAry.length > 1 ? textAry[0] + '...' : val;
    }
  });

  _.set(fields, 'beginTime', {
    label: t('lbl-beginTime'),
    sortable: true
  });

  _.set(fields, 'more', {
    label: t('lbl-more'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("div", {
        className: "icon-block"
      }, /*#__PURE__*/React.createElement("a", {
        title: t('lbl-edit'),
        onClick: function onClick() {
          return handleOpenDialog(row);
        }
      }, /*#__PURE__*/React.createElement("i", {
        className: "fas fa-list-alt"
      })));
    }
  });

  return /*#__PURE__*/React.createElement("div", {
    id: id
  }, /*#__PURE__*/React.createElement(Tabs, {
    id: "g-board-terminal-board-tabs",
    menu: tabsMenu,
    current: currentTab,
    onChange: function onChange(key) {
      return setCurrentTab(key);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "terminalBoard-table"
  }, /*#__PURE__*/React.createElement("div", {
    className: "table-head"
  }, /*#__PURE__*/React.createElement("div", {
    className: "left"
  }), /*#__PURE__*/React.createElement("div", {
    className: "tooltip-bar"
  }, /*#__PURE__*/React.createElement(SearchBar, {
    searchIconPosition: "right",
    placeholder: "Search",
    onSearch: function onSearch(search) {
      setKeyword(search);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fields,
    data: tableData,
    sort: tableSort,
    onSort: function onSort(sort) {
      return setTableSort(sort);
    }
  })), /*#__PURE__*/React.createElement(TablePagination, {
    component: "div",
    labelRowsPerPage: gt('global.lbl-per-page-row-count'),
    count: totalCount,
    page: currentPage,
    onChangePage: function onChangePage(e, newPage) {
      return setCurrentPage(newPage);
    },
    rowsPerPage: rowsPerPage,
    onChangeRowsPerPage: handleChangeRowsPerPage
  }))), /*#__PURE__*/React.createElement(TerminalBoardViewDetail, {
    detailData: detailData,
    onClose: handleCloseDialog
  }));
});
TerminalBoardView.defaultProps = {
  id: 'g-board-terminal-board-view'
};
TerminalBoardView.PropTypes = {
  id: PropTypes.string
};
export default TerminalBoardView;